import React, { useState } from "react";
import { ethers } from "ethers";
import { CONTRACT_ADDRESS, ABI } from "./constants";
import "./App.css";

function GetRoastData() {
  const [batchNumber, setBatchNumber] = useState("");
  const [roastData, setRoastData] = useState(null);
  const [blockNumber, setBlockNumber] = useState(null);
  const [transactionHash, setTransactionHash] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const alchemyProvider = new ethers.providers.JsonRpcProvider(
    "https://polygon-mainnet.g.alchemy.com/v2/R9SdVggsIrXqHxs2VqQhHmxlYj9fy1xE"
  );

  const contract = new ethers.Contract(CONTRACT_ADDRESS, ABI, alchemyProvider);

  const getRoastBatch = async () => {
    if (!batchNumber) {
      setErrorMessage("Bitte geben Sie eine Batch-ID ein.");
      return;
    }

    setErrorMessage("");
    setRoastData(null);
    setBlockNumber(null);
    setTransactionHash(null);

    try {
      // Event-Logs abrufen
      const filter = contract.filters.RoastBatchAdded(batchNumber);
      const logs = await contract.queryFilter(filter);

      if (logs.length === 0) {
        setErrorMessage("Keine Daten für diese Batch-ID gefunden.");
        return;
      }

      // Extrahiere den ersten Log und Transaktions-Hash
      const log = logs[0];
      const txHash = log.transactionHash;

      // Abfrage der Transaktionsdetails
      const txReceipt = await alchemyProvider.getTransactionReceipt(txHash);

      if (txReceipt) {
        setTransactionHash(txHash);
        setBlockNumber(txReceipt.blockNumber); // Blocknummer speichern
      }

      // Daten aus dem Smart Contract abrufen
      const data = await contract.getRoastBatch(batchNumber);

      const roastDetails = {
        batchNumber: data.batchNumber,
        beanOrigin: data.beanOrigin,
        beanType: data.beanType,
        beanSupplier: data.beanSupplier,
        beanHarvestYear: data.beanHarvestYear,
        beanMoistureDensity: data.beanMoistureDensity,
        roastDate: data.roastDate,
        roastDuration: data.roastDuration,
        temperatureProfile: data.temperatureProfile,
        roastColor: data.roastColor,
        roastingMachine: data.roastingMachine,
        roasterName: data.roasterName,
      };

      setRoastData(roastDetails);
    } catch (error) {
      console.error("Fehler beim Abrufen der Daten:", error);
      setErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.");
    }
  };

  const getExplorerLink = (blockNumber, txHash) => {
    if (blockNumber && txHash) {
      return `https://polygonscan.com/tx/${txHash}`;
    }
    return null;
  };

  return (
    <div className="App" style={{ textAlign: "left", marginLeft: "20px" }}>
      <h1>JABCoffee Roast Data</h1>
      <div>
        <label>
          Batch Number:
          <input
            type="text"
            value={batchNumber}
            onChange={(e) => setBatchNumber(e.target.value)}
            placeholder="Batch-ID eingeben"
            style={{ marginLeft: "10px" }}
          />
        </label>
        <button onClick={getRoastBatch} style={{ marginLeft: "10px" }}>
          Daten abrufen
        </button>
      </div>
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      {roastData && (
        <div style={{ marginTop: "20px" }}>
          <h3>Gefundene Röstcharge:</h3>
          <p><strong>Batch Number:</strong> {roastData.batchNumber}</p>
          <p><strong>Bean Origin:</strong> {roastData.beanOrigin}</p>
          <p><strong>Bean Type:</strong> {roastData.beanType}</p>
          <p><strong>Bean Supplier:</strong> {roastData.beanSupplier}</p>
          <p><strong>Harvest Year:</strong> {roastData.beanHarvestYear}</p>
          <p><strong>Moisture Density:</strong> {roastData.beanMoistureDensity}</p>
          <p><strong>Roast Date:</strong> {roastData.roastDate}</p>
          <p><strong>Roast Duration:</strong> {roastData.roastDuration}</p>
          <p><strong>Temperature Profile:</strong> {roastData.temperatureProfile}</p>
          <p><strong>Roast Color:</strong> {roastData.roastColor}</p>
          <p><strong>Roasting Machine:</strong> {roastData.roastingMachine}</p>
          <p><strong>Roaster Name:</strong> {roastData.roasterName}</p>
          {transactionHash && (
            <>
              <p><strong>Transaction Hash:</strong> {transactionHash}</p>
              <p>
                <a
                  href={getExplorerLink(blockNumber, transactionHash)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "blue", textDecoration: "underline" }}
                >
                  Transaktion im Blockchain Explorer anzeigen
                </a>
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default GetRoastData;
